import React, { useState, useEffect } from 'react'
import ReactDOMServer from 'react-dom/server'
import L, { Map } from 'leaflet'
import { Marker, useMap } from 'react-leaflet'
import { PieChart } from 'react-minimal-pie-chart'
import { formatNumber0 } from '../utilities/format'

interface Properties {
    superclusterRef: { [key: string]: any; } | undefined;
    options: any;
    data: any;
}

const iconPieChart = (item: any, options: any, mapContext: Map) => {
    // Add null check for options
    if (!options) {
        return L.divIcon({
            className: 'marker-pie-chart',
            html: '<div></div>'
        });
    }

    const getSizePieChart = () => {
        if (mapContext.getZoom() <= 10) {
            return 50;
        } else if (mapContext.getZoom() <= 18) {
            return 60;
        } else {
            return 80;
        }
    }

    const getDataPieChart = () => {
        if (!options.colorMapping) {
            return [];
        }
        
        return options.colorMapping.map((mapping: any) => {
            console.log('mapping', mapping);
            console.log('item', item);
            console.log('options', options);

            if (options.fieldName) {

                return {
                    value: item.entries.filter((entry: any) => entry[options.fieldName] === mapping.value).length,
                    color: mapping.color,
                }
            } else {                
                return {
                    value: item.entries.reduce((acc: number, curr: any) => {
                        console.log('curr', curr);
                        console.log('mapping', mapping);
                        return acc + curr[mapping.value];
                    }, 0),
                    color: mapping.color,
                }
            }
        });
    }

    return L.divIcon({
        className: 'marker-pie-chart',
        html: ReactDOMServer.renderToString(
            <div style={{
                width: (getSizePieChart() + 8) * 2,
                height: (getSizePieChart() + 8) * 2,
                transform: 'translate(-50%, -50%)'
            }}>
                <PieChart
                    data={getDataPieChart()}
                    radius={getSizePieChart()}
                    center={[getSizePieChart() + 8, getSizePieChart() + 8]}
                    viewBoxSize={[(getSizePieChart() + 8) * 2, (getSizePieChart() + 8) * 2]}
                    lineWidth={70}
                    // TODO: Allow to specify format in options
                    label={({ dataEntry }) => `${formatNumber0(dataEntry.value)}${options.suffix || ''}`}
                    labelPosition={100 - 70 / 2}
                    labelStyle={(index) => ({
                        fill: 'white',
                        fontSize: '12px',
                        fontFamily: 'Lato',
                    })}
                />
            </div>
        )
    })
}

const clusterByLatLon = (points: any) => {
    // TODO Move to cluster

    return Object.values(points.reduce((map: any, point: any) => {
        const key = `${point.lat}-${point.lon}`;

        map[key] = map[key] || { lat: point.lat, lon: point.lon, entries: [] };

        map[key].entries.push(point);

        return map;
    }, {}));
}

const RenderMarkerSuperCluster = (properties: Properties) => {
    const mapContext = useMap();
    const [groups, setGroups] = useState(clusterByLatLon(properties.data));
    const [currentZoom, setCurrentZoom] = useState(mapContext.getZoom());

    // Update zoom level when map zoom changes
    useEffect(() => {
        const handleZoomEnd = () => {
            setCurrentZoom(mapContext.getZoom());
        };

        mapContext.on('zoomend', handleZoomEnd);

        return () => {
            mapContext.off('zoomend', handleZoomEnd);
        };
    }, [mapContext]);

    // Comprehensive defensive guards after all hooks
    if (!properties) {
        console.error("[RenderMarkerSuperCluster] properties is null or undefined");
        return <div>Loading...</div>;
    }
    
    if (typeof properties !== "object") {
        console.error("[RenderMarkerSuperCluster] properties is not an object:", typeof properties, properties);
        return <div>Loading...</div>;
    }
    
    // Ensure properties.options exists and is an object
    if (!properties.options) {
        console.warn("[RenderMarkerSuperCluster] properties.options is null/undefined, using empty object");
        properties.options = {};
    }
    
    if (typeof properties.options !== "object") {
        console.warn("[RenderMarkerSuperCluster] properties.options is not an object, using empty object");
        properties.options = {};
    }

    console.log('Current zoom level:', currentZoom);

    return (
        <>
            {groups && groups.map((item: any, index: number) => {
                // Use a single condition to determine which marker to show
                if (!properties.options?.fieldName || currentZoom >= 12) {
                    // Show pie chart at higher zoom levels
                    return (
                        <Marker
                            key={index}
                            position={[item.lat, item.lon]}
                            icon={iconPieChart(item, properties.options || {}, mapContext)}
                        />
                    )
                } else {
                    let color = 'blue';

                    if (properties.options?.fieldName && properties.options?.colorMapping) {
                        // Show pin at lower zoom levels
                        const dominantIndex = item.entries.reduce((acc: number, curr: any) => {
                            const index = properties.options?.colorMapping?.findIndex((mapping: any) => mapping.value === curr[properties.options?.fieldName]) || -1;

                            if (index < acc) {
                                return index;
                            }

                            return acc;
                        },
                            properties.options?.colorMapping?.length - 1);

                        color = properties.options?.colorMapping?.[dominantIndex]?.color || 'blue';
                    }

                    console.log('color', color);

                    return (
                        <Marker
                            key={index}
                            position={[item.lat, item.lon]}
                            icon={L.divIcon({
                                html: `<svg width="30" height="45" viewBox="0 0 38 55" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 0C8.507 0 0 8.507 0 19c0 14.25 19 36 19 36s19-21.75 19-36c0-10.493-8.507-19-19-19z" fill="${color}"/>
                                        <circle cx="19" cy="19" r="8" fill="#FFFFFF"/>
                                      </svg>`,
                                className: 'custom-marker',
                                iconSize: [30, 45],
                                iconAnchor: [15, 45],
                                popupAnchor: [0, -45]
                            })}
                        />
                    )
                }
            })}
        </>
    )
}

export default React.memo(RenderMarkerSuperCluster)